<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaDados(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">LOJISTAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoLojistas = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)">Recarregar</v-btn>
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.situacao == true ? 'success' : 'error'">mdi-circle</v-icon>
            </p>
          </template>
          <template v-slot:[`item.delivery`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.delivery == true ? 'success' : 'error'">mdi-circle</v-icon>
            </p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoLojistas" persistent max-width="400px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row dense>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="WhatsApp*" outlined dense hide-details v-model="editedItem.whatsApp" v-mask="'(##) #####-####'" placeholder="Ex: (11) 99999-9999"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-switch inset v-model="editedItem.situacao" label="Ativo"></v-switch>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-switch inset v-model="editedItem.delivery" label="Delivery Consumidor"></v-switch>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-switch inset v-model="editedItem.deliveryTotem" label="Delivery Totem"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoLojistas = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarLojista">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'WhatsApp', align: 'start', value: 'whatsApp', },
          { text: 'Situação', value: 'situacao' },
          { text: 'Delivery', value: 'delivery' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' },
        ],
        conteudo: [],
      },
      dialogoLojistas: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        whatsApp: '',
        situacao: true,
        empresaId: '',
        delivery: false,
        deliveryTotem: false,
      },
      defaultItem: {
        nome: '',
        whatsApp: '',
        situacao: true,
        empresaId: '',
        delivery: false,
        deliveryTotem: false,
      },
      empresas: [],
      empresaSelecionada: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo lojista' : 'Editar lojista'
      },
    }),

    watch: {
      dialogoLojistas(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300);
        }
      }
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaDados(this.user.empresaId)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaDados(empresaId) {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + empresaId + '"}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
          }
        })
        this.isLoading = false
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoLojistas = true
        this.isLoading = false
      },

      async salvarLojista() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.situacao) {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id
          await axios.post(baseApiUrl + 'Lojistas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoLojistas = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaDados(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o cliente ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Lojistas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>
